import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
// slices
import mailReducer from "./slices/mail";
import chatReducer from "./slices/chat";
import blogReducer from "./slices/blog";
import userReducer from "./slices/user";
import productReducer from "./slices/product";
import calendarReducer from "./slices/calendar";
import kanbanReducer from "./slices/kanban";
import dataReducer from "../redux/slices/Action";
import Topup from "../redux/slices/WalletBalance";
import Login from "../redux/slices/userSignIn";
import Adminvalues from "../redux/slices/AdmimFieldValues";
import deleteRule from "../redux/slices/RemoveManually";
import roundWayDetailsReducer from "../redux/slices/roundWayFlights";
import UpdateWalletReducers from "./slices/UpdateWallet";
import UpdateTransactionReducer from "./slices/UpdateTransactionTable";
import agentWalletSlice from "./slices/AgentWallet";
import AuthSlice from "./slices/authSlice"
import sessionValidation from "./slices/sessionValidation"
// flight
import checkoutSlice from "./slices/checkoutSlice"
import testSlice from "./slices/testSlice";
import pinnedNavReducer from "./slices/pinnedNavSlice";
// ----------------------------------------------------------------------

const rootPersistConfig = {
  key: "root",
  storage,
  keyPrefix: "redux",
  whitelist: [],
};

const productPersistConfig = {
  key: "product , TopUp",
  storage,
  keyPrefix: "redux-",
  whitelist: ["sortBy", "checkout"],
};

const rootReducer = combineReducers({
  mail: mailReducer,
  chat: chatReducer,
  blog: blogReducer,
  user: userReducer,
  calendar: calendarReducer,
  kanban: kanbanReducer,
  data: dataReducer,
  signIn: persistReducer(productPersistConfig, Login),
  delete: deleteRule,
  adminvalues: Adminvalues,
  TopUp: persistReducer(productPersistConfig, Topup),
  product: persistReducer(productPersistConfig, productReducer),
  roundWayDetails: roundWayDetailsReducer,
  updateWallet: UpdateWalletReducers,
  updateTransactionTable: UpdateTransactionReducer,
  agentWalletSlice : agentWalletSlice ,
  AuthSlice,
  checkoutSlice,
  sessionValidation,
  pinnedNav: pinnedNavReducer,
});

export { rootPersistConfig, rootReducer };
